var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useDareAssignee } from 'root/src/client/logic/project/hooks/useDareAssignee';
import { usePreferredPlatform } from 'root/src/client/logic/dropEvent/hooks/usePreferredPlatform';
import { useUserHasGame } from 'root/src/client/v2/drop/hooks/useUserHasGame';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { KeySelectionModal } from 'root/src/client/v2/drop/features/KeySelectionModal/components/KeySelectionModal';
import { Platform } from 'root/src/shared/@types/platforms';
import { useCreateProjectDropMutation } from 'root/src/client/v2/drop/hooks/useCreateProjectDropMutation';
import { InitialProductDisplayModal, } from 'root/src/client/v2/drop/features/KeySelectionModal/components/InitialProductDisplayModal';
import { useAppDispatch } from 'root/src/client/logic/helpers/useStore';
import { useDropShortUrl } from 'root/src/client/v2/drop/hooks/useDropShortUrl';
import { useLocalStorage } from 'root/src/client/web/hooks/useLocalStorage';
import { DARE_SUBMISSION_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds';
import displayModal from 'root/src/client/logic/modal/thunks/displayModal';
import { PreferredPlatformReachedMaxDaresModal, } from 'root/src/client/v2/creator/components/PreferredPlatformReachedMaxDaresModal';
import toast from 'react-hot-toast';
import { useIsAuthenticated } from 'root/src/client/v2/auth/hooks/useIsAuthenticated';
import { useMaxDaresByPlatforms } from 'root/src/client/logic/dropEvent/hooks/useMaxDaresByPlatforms';
import { useIsAdmin } from 'root/src/client/v2/auth/hooks/useIsAdmin';
import { useIsBrand } from 'root/src/client/v2/auth/hooks/useIsBrand';
import { isDropComingSoon } from 'root/src/shared/drops/helpers/isDropComingSoon.helper';
import { ProjectStatus } from 'root/src/shared/@types/project';
import { redirectToCreateBrandProjectForm, } from 'root/src/client/logic/dropEvent/thunks/redirectToCreateBrandProjectForm';
import { isDareAnyPlatform } from 'root/src/shared/drops/helpers/dropDare.helpers';
import SignInWithProviderModal from 'root/src/client/web/auth/features/SignInWithProviderModal';
import { CompletionType } from 'root/src/shared/rewards/constants';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { Provider } from 'root/src/shared/@types/providers';
import { ScopeSet } from 'root/src/shared/@types/auth';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { UpgradePermissionsModal } from 'root/src/client/v2/auth/components/UpgradePermissionsModal';
import { TRPCClientError } from '@trpc/client';
import { generateMaxDaresText } from 'root/src/client/logic/project/thunks/createProjectDrop';
const ManualModeDescription = () => {
    return (<div>
			<p className="text-sm">We will select randomly a one or more of your viewers to receive a reward, and we'll send you an email with instructions on how to do that and who won.</p>
		</div>);
};
const AutoModeDescription = () => {
    return (<div>
			<p className="text-sm">This Dare will be automatically completed once you fulfil description requirements.</p>
			<p className="text-sm">Your viewers will have chance to win a reward as a result of this Dare.</p>
			<p className="text-sm">To be able to accept this Dare, you need to give us permission to access your Twitch account.</p>
			<p className="text-sm">We will select randomly a one or more of your viewers to receive a reward, and announce them in your chat.</p>
		</div>);
};
const GameIntegratedPermissionModal = ({ onContinue }) => {
    return (<UpgradePermissionsModal autoLabel="I want to automatically announce winners in my chat (Recommended)" manualLabel="I will announce winners on my own (Not recommended)" renderDescription={isAutoModeEnabled => (isAutoModeEnabled ? <AutoModeDescription /> : <ManualModeDescription />)} scopeSet={ScopeSet.creatorPlus} provider={Provider.Twitch} onContinue={onContinue}/>);
};
export const useAcceptDare = ({ drop, dare, refetchDropEvent, keySelectionModalComponent: KeySelectionModalComponent = KeySelectionModal, initialProductDisplayModalComponent: InitialProductDisplayComponent = InitialProductDisplayModal, showModal: injectedShowModal, displaySubmissionPlatformModal: injectedDisplaySubmissionPlatformModal, displayPreferredPlatformReachedMaxDaresModal: injectedDisplayPreferredPlatformReachedMaxDaresModal, displayGameIntegratedPermissionModal: injectedDisplayGameIntegratedPermissionModal, displayReauthModal: injectedDisplayReauthModal, displayHowToEarnPointsModal: injectedDisplayHowToEarnPointsModal, displayNoMoreRewardModal: injectedDisplayNoMoreRewardModal, displayDeliveryRatioTooLowModal: injectedDisplayDeliveryRatioTooLowModal, displayVerificationPendingModal: injectedDisplayVerificationPendingModal, displayNoInitialKeysModal: injectedDisplayNoInitialKeysModal, displayConfirmEmailModal: injectedDisplayConfirmEmailModal, }) => {
    var _a, _b;
    const [showSubmissionModal] = useLocalStorage('showSubmissionModal', true);
    const [showPlatformAdjustedModal] = useLocalStorage('showPlatformAdjustedModal', true);
    const [submitting, setSubmitting] = useState(false);
    const utils = trpc.useUtils();
    const modal = useModal();
    const defaultShow = (node, options) => {
        var _a;
        return modal.show(node, { isCloseable: (_a = options === null || options === void 0 ? void 0 : options.closeable) !== null && _a !== void 0 ? _a : true });
    };
    const showModal = injectedShowModal !== null && injectedShowModal !== void 0 ? injectedShowModal : defaultShow;
    const { isAdmin } = useIsAdmin();
    const { isBrand } = useIsBrand();
    const isAdminOrBrand = isAdmin || isBrand;
    const assignee = useDareAssignee({ dare, fallbackDrop: drop });
    const preferredPlatform = usePreferredPlatform();
    const isAuthenticated = useIsAuthenticated();
    const brandId = (_b = (_a = drop === null || drop === void 0 ? void 0 : drop.brand) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : drop === null || drop === void 0 ? void 0 : drop.brandId;
    const userHasGameQuery = useUserHasGame({ dropId: drop === null || drop === void 0 ? void 0 : drop.id, brandId }, false);
    const shortUrlQuery = useDropShortUrl({ dropId: drop === null || drop === void 0 ? void 0 : drop.id, enabled: false });
    const createProjectDropMutation = useCreateProjectDropMutation();
    const creatorCanAccept = useCreatorCanAccept(drop);
    const initialProduct = (drop === null || drop === void 0 ? void 0 : drop.initialProduct) || [];
    const legacyDisplayPreferredPlatformReachedMaxDaresModal = usePreferredPlatformReachedMaxDaresModal();
    const displayPreferredPlatformReachedMaxDaresModal = injectedDisplayPreferredPlatformReachedMaxDaresModal !== null && injectedDisplayPreferredPlatformReachedMaxDaresModal !== void 0 ? injectedDisplayPreferredPlatformReachedMaxDaresModal : legacyDisplayPreferredPlatformReachedMaxDaresModal;
    const legacyDisplaySubmissionPlatformModal = useSubmissionPlatformModal();
    const displaySubmissionPlatformModal = injectedDisplaySubmissionPlatformModal !== null && injectedDisplaySubmissionPlatformModal !== void 0 ? injectedDisplaySubmissionPlatformModal : legacyDisplaySubmissionPlatformModal;
    const legacyDisplayGameIntegratedPermissionModal = () => new Promise(resolve => modal.show(<GameIntegratedPermissionModal onContinue={() => resolve(true)}/>, {
        onClose: () => resolve(false),
    }));
    const displayGameIntegratedPermissionModal = injectedDisplayGameIntegratedPermissionModal !== null && injectedDisplayGameIntegratedPermissionModal !== void 0 ? injectedDisplayGameIntegratedPermissionModal : legacyDisplayGameIntegratedPermissionModal;
    const legacyDisplayReauthModal = () => modal.show(<ModalLayout>
			<SignInWithProviderModal props={{
            item: {
                provider: Provider.Twitch,
                header: 'Sign in to continue',
                label: 'Please re-authenticate your Twitch account to accept this Dare.',
            },
        }}/>
		</ModalLayout>);
    const displayReauthModal = injectedDisplayReauthModal !== null && injectedDisplayReauthModal !== void 0 ? injectedDisplayReauthModal : legacyDisplayReauthModal;
    // The redesign injects its own error modals (below). When it does, tell the thunk to skip the
    // legacy modals so we can render the redesign ones from the thrown `code` (single feedback).
    const suppressErrorModals = Boolean(injectedDisplayHowToEarnPointsModal
        || injectedDisplayNoMoreRewardModal
        || injectedDisplayDeliveryRatioTooLowModal
        || injectedDisplayVerificationPendingModal);
    const redirectToCreatProjectForm = useRedirectToCreateProject();
    const comingSoon = isDropComingSoon(drop);
    const reacceptProjectMutation = trpc.project.reacceptProject.useMutation();
    // Asks whether the drop still has a join key to grant before the key picker opens, so a depleted
    // drop can offer the restock waitlist instead of a picker that cannot deliver. Fails open on any
    // error: createProjectDrop runs the authoritative gate on submit either way, and a check that
    // cannot answer must not stand between a creator and an accept the server would allow.
    const fetchInitialProductAvailability = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!assignee) {
            return undefined;
        }
        try {
            return yield utils.drops.getInitialProductAvailability.fetch({
                dropId: drop.id,
                platform: assignee.platform,
                platformId: assignee.id,
            });
        }
        catch (error) {
            console.error(error);
            return undefined;
        }
    });
    const onAcceptDare = ({ setHover = defaultSetHover, onSuccess } = {}) => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d, _e;
        if (!isAuthenticated) {
            return;
        }
        if (isAdminOrBrand) {
            redirectToCreatProjectForm({
                id: dare.id,
                title: dare.title,
                description: dare.description,
                paymentInfo: dare.paymentInfo,
                campaign: { name: drop.campaignName, campaignId: drop.id },
            });
            return;
        }
        if (!creatorCanAccept || !assignee || comingSoon) {
            return;
        }
        if (submitting) {
            return;
        }
        const isAnyPlatformDare = isDareAnyPlatform(dare);
        const isGameIntegratedDare = ((_c = dare.completion) === null || _c === void 0 ? void 0 : _c.type) === CompletionType.GAME_INTEGRATED;
        if (isGameIntegratedDare) {
            const canAcceptGameIntegratedDare = yield utils.dares.getCanAcceptGameIntegratedDare.fetch({
                platform: Platform.Twitch,
            });
            if (!canAcceptGameIntegratedDare) {
                displayReauthModal();
                return;
            }
            const hasValidToken = yield utils.auth.hasValidTokenScope.fetch({
                platform: Platform.Twitch,
                scopeSet: ScopeSet.creatorPlus,
            });
            if (!hasValidToken) {
                const shouldContinueWithoutPermissions = yield displayGameIntegratedPermissionModal();
                if (!shouldContinueWithoutPermissions) {
                    return;
                }
            }
        }
        const isPreferredPlatformReachedMaxDaresModalVisible = isAnyPlatformDare
            && showPlatformAdjustedModal
            && preferredPlatform
            && preferredPlatform !== assignee.platform;
        const isPlatformSubmissionModalVisible = isAnyPlatformDare
            && showSubmissionModal;
        if (isPreferredPlatformReachedMaxDaresModalVisible) {
            const isAccepted = yield displayPreferredPlatformReachedMaxDaresModal(assignee.platform);
            if (!isAccepted) {
                return;
            }
        }
        if (isPlatformSubmissionModalVisible) {
            const isAccepted = yield displaySubmissionPlatformModal();
            if (!isAccepted) {
                return;
            }
        }
        const createProjectPayload = {
            dropDareId: dare.id,
            paymentInfo: dare.paymentInfo,
            assignees: [assignee],
            dropEvent: drop,
            userHasGame: false,
            // Rides the payload rather than the mutation call below, so the key selection modal (which
            // submits this payload itself) gets the redesign prompt too.
            displayConfirmEmailModal: injectedDisplayConfirmEmailModal,
        };
        const { data: userHasGame = false } = yield userHasGameQuery.refetch();
        if (!userHasGame) {
            if (initialProduct.length) {
                if (injectedDisplayNoInitialKeysModal) {
                    const availability = yield fetchInitialProductAvailability();
                    if (availability === null || availability === void 0 ? void 0 : availability.isBlocked) {
                        // Carries the payload: skipping the key picker also skips its "I already own this game"
                        // button, and that declaration is still a way into the drop with the pool empty.
                        injectedDisplayNoInitialKeysModal({ isWaiting: availability.isWaiting, formData: createProjectPayload });
                        return;
                    }
                }
                showModal(<KeySelectionModalComponent dropEvent={drop} payload={createProjectPayload} dare={dare}/>);
                return;
            }
        }
        const showSuccessModal = () => __awaiter(void 0, void 0, void 0, function* () {
            if ((userHasGame && (drop.isGameFree || !initialProduct))) {
                const shortUrl = yield shortUrlQuery.refetch();
                return showModal(<InitialProductDisplayComponent dropEvent={drop} dare={dare} shortUrl={shortUrl.data}/>, {
                    closeable: false,
                });
            }
            return null;
        });
        setSubmitting(true);
        setHover(true);
        try {
            if (dare.status === ProjectStatus.Rejected) {
                yield reacceptProjectMutation.mutateAsync({
                    dropDareId: dare.id,
                    assignee: {
                        platformId: assignee.id,
                        platform: assignee.platform,
                    },
                });
            }
            else {
                yield createProjectDropMutation.mutateAsync(Object.assign(Object.assign({}, createProjectPayload), { userHasGame,
                    showSuccessModal,
                    onSuccess,
                    suppressErrorModals }));
            }
            if (refetchDropEvent) {
                // Keep the accept button in its loading state until the drop refetch settles, so the card
                // flips to its post-accept CTA (Deliver) before the spinner clears. A refetch failure must
                // not surface as an accept error (the dare was created), so it is swallowed here.
                try {
                    yield refetchDropEvent();
                }
                catch (_f) {
                    // ignore refetch failure
                }
            }
        }
        catch (error) {
            console.error(error);
            if (error instanceof TRPCClientError) {
                const props = (_d = error.data) === null || _d === void 0 ? void 0 : _d.props;
                if ((props === null || props === void 0 ? void 0 : props.code) === 'RequirementsNotSatisfied') {
                    const { assigneesNotSatisfying } = props;
                    const [{ followerCount, averageCcv, maxDares, platform, averageYoutubeViews }] = assigneesNotSatisfying;
                    const message = generateMaxDaresText(followerCount, averageCcv, averageYoutubeViews, maxDares, platform);
                    toast.error(message, { duration: 5000 });
                    return;
                }
                toast.error(error.message);
                return;
            }
            // Redesign error modals (opt-in). The thunk was told to skip its legacy modal for these
            // codes; render the injected redesign modal instead and skip the toast (no double feedback).
            const code = error === null || error === void 0 ? void 0 : error.code;
            if (code === 'EmailConfirmationCancelled') {
                // The creator chose to change their email and is on their way to that page. Nothing failed,
                // so say nothing.
                return;
            }
            if (code === 'NotEnoughInitialProducts' && injectedDisplayNoInitialKeysModal) {
                // A safety net for the pool emptying between the pre-accept check and this submit. No
                // `formData`: the gate only fires for a creator still owed a key, so declaring the game is
                // not what got them here and re-offering it would be nonsense. The gate waitlists them as it
                // turns them away, hence `isWaiting`.
                injectedDisplayNoInitialKeysModal({ isWaiting: true });
                return;
            }
            if (code === 'CampaignTermsNotAccepted' && injectedDisplayHowToEarnPointsModal) {
                injectedDisplayHowToEarnPointsModal();
                return;
            }
            if (code === 'NotEnoughKeys' && injectedDisplayNoMoreRewardModal) {
                injectedDisplayNoMoreRewardModal(error.formData);
                return;
            }
            if (code === 'DeliveryRatioTooLow' && injectedDisplayDeliveryRatioTooLowModal) {
                injectedDisplayDeliveryRatioTooLowModal((_e = error.campaignsData) !== null && _e !== void 0 ? _e : []);
                return;
            }
            if (code === 'VerificationPending' && injectedDisplayVerificationPendingModal) {
                injectedDisplayVerificationPendingModal();
                return;
            }
            toast.error(error.error);
        }
        finally {
            setSubmitting(false);
            setHover(false);
        }
    });
    return { onAcceptDare };
};
const usePreferredPlatformReachedMaxDaresModal = () => {
    const modal = useModal();
    return (targetPlatform) => new Promise((resolve) => {
        return modal.show(<PreferredPlatformReachedMaxDaresModal platform={targetPlatform} onClose={() => {
                modal.hide();
                resolve(false);
            }} onSubmit={() => {
                modal.hide();
                resolve(true);
            }}/>, {
            isCloseable: false,
        });
    });
};
const useSubmissionPlatformModal = () => {
    const dispatch = useAppDispatch();
    return () => new Promise((resolve) => {
        dispatch(displayModal(DARE_SUBMISSION_MODAL_MODULE_ID, {
            onCancel: () => {
                displayModal(undefined);
                resolve(false);
            },
            onAccept: () => __awaiter(void 0, void 0, void 0, function* () {
                // !!!! This displayModal(undefined) is important.
                // !!!! Otherwise, we're not closing modal properly, leading to creating duplicate dares.
                displayModal(undefined);
                resolve(true);
            }),
            onClose: () => {
                displayModal(undefined);
                resolve(false);
            },
        }));
    });
};
const useCreatorCanAccept = (drop) => {
    const maxDares = useMaxDaresByPlatforms({ fallbackDrop: drop });
    const { isBrand } = useIsBrand();
    const { isAdmin } = useIsAdmin();
    return !isAdmin && !isBrand && maxDares > 0;
};
const defaultSetHover = () => null;
const useRedirectToCreateProject = () => {
    const dispatch = useAppDispatch();
    return (params) => {
        dispatch(redirectToCreateBrandProjectForm(params));
    };
};
